import { mergeMap } from 'rxjs/operators';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { ScheduleAction } from '../schedule.action';
import { ScheduleTranslator } from '../schedule.translator';

type IDependencies = IClientApiDependencySegment;

export const updateScheduleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(ScheduleAction.update.started),
  mergeMap(({ params, resolve, reject }) => {
    const { scheduleId } = params;

    return dependencies.api.updateSchedule({ ...ScheduleTranslator.toApi(params), scheduleId }).pipe(
      mergeMap(() => {
        resolve?.();
        return [
          ScheduleAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          ScheduleAction.update.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
